<template>
  <div>
    <popup ref="popup" :loading="popupLoading" :appendToBody="true">
      <div slot="body" style="margin-top: -15px">

        <el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="60px">

          <el-row>
            <el-col :span="24">
              <el-table class="table" :data="parameter" stripe border height="auto">
                <el-table-column label="序号" width="60px" type="index">
                  <template slot-scope="scope">
                    {{ idx }}/{{ sizeConus }}
                  </template>
                </el-table-column>
                <el-table-column prop="mobile" label="咨询量" min-width="75px">
                  <template slot-scope="scope">
                    <b v-if="formParameter.sex == '女'" style="font-size: 18px;color:deeppink;">{{ formParameter.name
                      }}</b>
                    <b v-else style="font-size: 18px;color: #3333CC;">{{ formParameter.name }}</b> <br>
                    <el-image v-has-permission-code-and="'1000001501345'" v-if="formParameter.hasresume" title="点击查看简历"
                      style="width:59px; height: 25px" :src="'/static/shresume.png'"
                      :preview-src-list="[(baseUrl + '/statics/resume24364/' + formParameter.mobile + '.jpg?' + Math.random())]">
                    </el-image>
                    <br>
                    {{ scope.row.mobile }}

                  </template>
                </el-table-column>
                <el-table-column prop="name" label="跟进人" width="75px">
                  <template slot-scope="scope">
                    <el-tag type="warning" size="mini" v-if="scope.row.dyer">{{ scope.row.dyer }}</el-tag>
                    <el-tag type="success" size="mini" v-if="scope.row.zxer && me.role != 'dy'">{{ scope.row.zxer
                      }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="state" min-width="80px" label="状态与评价">
                  <template slot-scope="scope">
                    <el-rate disabled show-text :max="4" v-model="scope.row.rank"
                      :texts="['D', 'C', 'B', 'A']"></el-rate>
                    <el-select v-model="scope.row.state" placeholder="请选择">
                      <el-option v-for="item in ['有意向', '可跟进', '意向不大', '无意向', '已上门', '已报名', '未接通', '废量']" :key="item"
                        :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column min-width="70px" prop="city" label="当前所在城市">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.city" autocomplete="off"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="interviewtime" label="信息" min-width="70">
                  <template slot-scope="scope">
                    <el-tag type="success" :title="scope.row.interviewtime" v-if="scope.row.interviewtime"
                      size="mini">{{ scope.row.interviewtime }}已上门</el-tag>
                    <el-tag type="danger" :title="scope.row.invitetime" v-if="scope.row.invitetime" size="mini">{{
      scope.row.invitetime }}已测评</el-tag>
                    <el-tag type="danger" v-if="scope.row.present" size="mini">已辅助</el-tag>
                  </template>
                </el-table-column>
                <el-table-column min-width="300px" prop="remark" label="跟进记录">
                  <template slot-scope="scope">
                    <span v-if="grade == '挑低学历'">
                      <el-button type="danger" v-if="(!scope.row.xlconusid)" :loading="confirmLoading"
                        @click="confirm2()">转学历咨询数据{{ grade }}</el-button>
                      <span v-else> 已转学历数据成功</span>
                    </span>
                    <el-input type="textarea" v-else :rows="4" v-model="scope.row.txt" autocomplete="off"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="hasresume" v-if="grade != '挑低学历'" width="110px" label="">
                  <template slot-scope="scope">
                    <el-button type="primary" :loading="confirmLoading" @click="confirm()">提交跟进</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>

          </el-row>
          <el-row :style="formParameter.sex == '女' ? 'background-color: #FFCCCC;' : 'background-color:#66CCFF;'">
            <el-col :span="3">
              <el-form-item label="性别" prop="sex">
                <el-select size="mini" v-model="formParameter.sex" placeholder="请选择">
                  <el-option v-for="item in ['男', '女']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="意向" prop="post">
                <el-select size="mini" v-model="formParameter.post" placeholder="请选择">
                  <el-option v-for="item in ['全栈', '后端', '前端', '5G', '其他']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="学校" prop="schoolid">
                <el-input size="mini" v-model="formParameter.schoolid" autocomplete="off"></el-input></el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="学历" prop="grade">
                <el-select size="mini" v-model="formParameter.grade" placeholder="请选择">
                  <el-option v-for="item in ['本科', '大专', '研究生', '低学历']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="专业" prop="subject">
                <el-input size="mini" v-model="formParameter.subject" autocomplete="off"></el-input></el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="毕业" prop="gradedate">
                <el-date-picker size="mini" v-model="formParameter.gradedate" value-format="yyyy" type="year"
                  placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :style="formParameter.sex == '女' ? 'background-color: #FFCCCC;' : 'background-color:#66CCFF;'">

            <el-col :span="16">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="formParameter.remark" autocomplete="off"></el-input></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="danger" title="请跟据简历、电话沟通情况修正咨询量信息" size="mini"
                v-has-permission-code-and="'100000150085'" @click="updated()">信息更新</el-button>
              <el-button title="体验做题只能布置一次，第二次请在体验班级中布置到咨询者" v-has-permission-code-and="'1000001501000'" type="success"
                size="mini" @click="toTest()">体验做题</el-button>
              <el-button v-has-permission-code-and="'1000001501005'" type="warning" size="mini"
                @click="toHelp()">申请辅助</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-table class="table" :data="listRecords" stripe border height="auto">
          <el-table-column label="序号" width="50px" type="index">
            <template slot-scope="scope">
              {{ sizeRecord - scope.$index }}
            </template>
          </el-table-column>
          <el-table-column prop="gjdate" label="跟进时间" width="140px">
          </el-table-column>
          <el-table-column prop="uid" width="70px" label="跟进人">
          </el-table-column>
          <el-table-column width="70px" prop="rank" label="评价">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini" v-if="scope.row.rank == 1">D量</el-tag>
              <el-tag type="warning" size="mini" v-if="scope.row.rank == 2">C量</el-tag>
              <el-tag size="mini" v-if="scope.row.rank == 3">B量</el-tag>
              <el-tag type="success" size="mini" v-if="scope.row.rank == 4">A量</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="state" width="100px" label="状态"> </el-table-column>
          <el-table-column prop="city" width="120px" label="城市"> </el-table-column>

          <el-table-column prop="remark" label="跟进情况"> </el-table-column>
          <el-table-column label="操作" fixed="right" width="65px">
            <template slot-scope="scope">
              <div class="dataTable-operator">
                <el-button type="text" v-show="scope.row.id" v-has-permission-code-and="'1000001500250005'"
                  @click="remove(scope.$index, scope.row)" size="mini">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div slot="footer" style="text-align: center">
        <el-button :type="prebtn" size="medium" round :loading="confirmLoading" @click="move(-1)">{{ prebtn == "primary"
      ?
      "上一条" : "--end--" }}</el-button>
        <el-button type="danger" @click="close" size="medium">关闭</el-button>
        <el-button :type="nextbtn" size="medium" round :loading="confirmLoading" @click="move(1)">{{ nextbtn ==
      "primary"
      ? "下一条" : "--end--" }}</el-button>
      </div>


    </popup>
    <add ref="add"></add>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :model="examform" label-width="120px">
        <el-form-item label="考试名称">
          <el-input v-model="examName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="试卷">
          <el-select v-model="examform.pjtxt1" placeholder="请选择试卷">
            <el-option v-for="(v, idx) in expaperList" :key="v.id" :label="v.value" :value="idx"></el-option>
          </el-select>
          <div v-if="examform.pjtxt1 == 0 || examform.pjtxt1">
            <span v-if="expaperList[examform.pjtxt1]">
              {{ expaperList[examform.pjtxt1].isMobile ? '支持移动端，可自动判卷; ' : '' }} {{ expaperList[examform.pjtxt1].mark }}
            </span>
          </div>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="toTestConus">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="申请咨询助攻" :visible.sync="helpDialogVisible" width="30%">

      <el-form :model="helpform" label-width="80px" >
        <el-form-item label="助攻级别">
          <el-radio v-model="helpform.level" @change="changeHelp" label="1">打击型</el-radio>
          <el-radio v-model="helpform.level" @change="changeHelp" label="2">引导型</el-radio>
          <el-radio v-model="helpform.level" @change="changeHelp" label="3">基础型</el-radio>
        </el-form-item>
        <el-form-item label="助攻队友">
          <el-select v-model="helpform.zxer" placeholder="请选择">
            <el-option v-for="v in zxs" :key="v.id" :label="v.name" :value="v.name"></el-option>
          </el-select>
        </el-form-item>
        <span style="color: red;">{{ helpTxt }}</span>
        <el-form-item label="助攻内容">
          <el-input type="textarea" :rows="3" v-model="helpform.txt" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="helpDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmHelp">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultation/consultation.js";
import apircd from "@/api/consu/consultationrecord/consultationrecord.js";

import apiStu from "@/api/stus/student/student.js";

import apiExp from '@/api/exams/exampaper/exampaper.js';
import add from '@/views/stu/stu/add.vue';
import constant from "@/util/constant.js";

export default {
  name: "attckone",
  components: {
    popup,
    add
  },
  data() {
    return {
      baseUrl: constant.serverUrl,
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      listRecords: [],
      sizeRecord: 0,
      remark: "",
      me: "",
      zxs: [],
      zxsorg: [],
      dyrorg: [],
      helpTxt: "3-5分钟,目的是告诉技术很不足，项目经验相差甚远",
      isCangj: true,
      isCangjTxt: true,

      listConus: [],
      idx: 1,
      sizeConus: 1,
      prebtn: "info",
      nextbtn: "primary",

      dialogTitle: '',
      dialogFormVisible: false,
      expaperList: [],
      examform: {},
      examName: '基础知识测评',
      realExamName: '',
      grade: "",

      helpDialogVisible: false,
      helpform: {},
      listNeedFlush: 0
    };
  },
  methods: {
    changeHelp() {

      this.helpform.zxer = "";
       
      if (this.helpform.level == "1") {
        this.helpTxt = "3-5分钟,目的是告诉技术很不足，项目经验相差甚远";
        if (this.me.role == "ad" || this.me.role == "mg") {
          this.zxs = this.zxsorg;
        }
      } else if (this.helpform.level == "2") {
        this.helpTxt = "10分钟以上,告诉其技术很不足,分析当前就业环境，逐步引导转向学徒培训，通过职业规划使其信服";
        if (this.me.role == "ad" || this.me.role == "mg") {
          this.zxs = this.zxsorg;
        }
      } else if (this.helpform.level == "3") {
        this.helpTxt = "以人事专员的视角简单了解下有没有培训想法，点到为止";
        if (this.me.role == "ad" || this.me.role == "mg") {
          this.zxs = this.dysorg;
        }
      }
   

    },
    updated() {
      let param = {
        id: this.formParameter.id, sex: this.formParameter.sex, post: this.formParameter.post,
        schoolid: this.formParameter.schoolid, grade: this.formParameter.grade, subject: this.formParameter.subject,
        gradedate: this.formParameter.gradedate, remark: this.formParameter.remark
      }
      api.update(param, res => {
        //this.listNeedFlush++;
        this.$utils.msg.success(res.msg);
      }, err => {
        this.$utils.msg.warning(err.msg);
      })

    },
    toHelp() {
      this.helpform = { level: "1" }
      this.helpDialogVisible = true
    }, confirmHelp() {

      this.confirmLoading = true;
      let row = this.listConus[this.idx - 1]
      let txt = this.me.name + "-申请-" + this.helpform.zxer + (this.helpform.level == "1" ? "【辅助打击】" : "【引导辅助】") + this.helpform.txt

      row.img = txt

      api.attact(
        { ids: [row.id], zxer: this.helpform.zxer, cities: [row.city], states: [row.state], remarks: [row.img] },
        (response) => {
          this.$utils.msg.success(response.msg);
          this.confirmLoading = false;
          this.listRecords.splice(0, 0, {
            gjdate: "刚刚",
            remark: txt,
            uid: this.helpform.zxer,
            rank: row.rank,
            city: row.city,
            state: row.state
          });
          this.sizeRecord++;

          this.helpDialogVisible = false
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
          this.confirmLoading = false;
        }
      )

    },

    toTest() {
      apiExp.tiyanlist({}, res => {
        this.expaperList = res.data
        this.dialogFormVisible = true
      })

    }, toTestConus() {

      let exmp = this.expaperList[this.examform.pjtxt1]

      this.examform.name = this.parameter[0].name;
      this.examform.consu = this.parameter[0].id;
      this.examform.sex = this.parameter[0].sex == '女' ? 2 : 1;
      this.examform.mobile = this.parameter[0].mobile;
      this.examform.xueli = this.parameter[0].xueli;
      this.examform.school = this.parameter[0].schoolid;
      this.examform.gradedate = this.parameter[0].gradedate;
      this.examform.subject = this.parameter[0].subject;
      this.examform.age = this.parameter[0].age;
      this.examform.email = this.parameter[0].email;
      this.examform.pjtxt1 = exmp.id
      this.examform.pjtxt2 = exmp.isMobile
      this.examform.me = this.me.name

      this.examform.rname = this.examName;

      apiStu.tiyan(this.examform, res => {
        this.dialogFormVisible = false

        //添加一条跟进记录
        this.confirmLoading = true;

        let param = {
          ids: [this.parameter[0].id],
          remarks: ["开线上体验账号,布置测评[" + exmp.value + "]"],
          states: ["已测评"],
        };

        api.attact(
          param,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.listRecords.splice(0, 0, {
              gjdate: "刚刚",
              remark: param.remarks[0],
              states: "已测评",
              uid: "自己"
            });
            this.sizeRecord++;
            this.remark = "";
            this.$utils.msg.success("添加成功");
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      }, err => {
        this.$utils.msg.warning(err.data);
      })

    },
    //打开弹框
    open(index, list, me, zxs, dys, title, grade, disabled, size) {

      this.grade = grade;
      this.helpform.zxer = null

      this.listConus = list;
      this.sizeConus = this.listConus.length;
      this.idx = index + 1;

      if (this.idx == 1) {
        this.prebtn = "info";
      } else {
        this.prebtn = "primary";
      }

      if (this.idx == this.sizeConus) {
        this.nextbtn = "info";
      } else {
        this.nextbtn = "primary";
      }

      this.formParameter = list[index];
      this.parameter = [this.formParameter];

      this.dialogTitle = this.formParameter.name + '-线上测评布置'
      this.disabled = disabled;

      this.me = me;
      // console.log("me  >>>>>>>  ", me)
      this.zxs = zxs;
      if (this.me.role == "ad" || this.me.role == "mg") {
        this.zxsorg = zxs;
        this.dysorg = dys;
      }

      this.checkIsCangj();

      if (title.length > 6) {
        this.listNeedFlush = 1
      } else {
        this.listNeedFlush = 0
      }

      this.$refs.popup.open(title, "75%");
      this.$nextTick(() => {
        this.init();
      });
    }, //删除
    remove(index, row) {
      let parameter = {
        rid: row.id,
      };

      if (row.uid == this.me.name || (this.me.role == "ad" || this.me.role == "mg")) {
      } else {

        if (row.remark.indexOf(this.me.name + "-") == 0) {

        } else {
          this.$utils.msg.warning("只能删除自己的");
          return false;
        }
      }

      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.delRecordByRid(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.listRecords.splice(index, 1);
            this.sizeRecord--;
            this.listNeedFlush++;

          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.votes = [];
      this.$refs.popup.close();
      //("this.listNeedFlush ",this.listNeedFlush )
      if (this.listNeedFlush > 0) {
        this.listNeedFlush = 0
        this.$emit("flush");
      }

    },
    move(flag) {

      if (
        (flag < 0 && this.idx > 1) ||
        (flag > 0 && this.idx < this.sizeConus)
      ) {
        this.idx += flag;

        if (this.idx == 1) {
          this.prebtn = "info";
          if (this.idx != this.sizeConus) {
            this.nextbtn = "primary";
          }
        } else if (this.idx == this.sizeConus) {
          this.nextbtn = "info";
          if (this.idx != 1) {
            this.prebtn = "primary";
          }
        } else {
          this.prebtn = "primary";
          this.nextbtn = "primary";
        }
        this.confirmLoading = true;

        this.formParameter = this.listConus[this.idx - 1]
        this.formParameter.vdate = new Date();
        this.parameter = [this.formParameter];

        this.checkIsCangj();

        apircd.list({ coid: this.formParameter.id }, (res) => {
          if (res.data.records) {
            this.listRecords = res.data.records;
            if (this.listRecords) {
              this.sizeRecord = this.listRecords.length;
              if (this.listRecords[0] && this.listRecords[0].city) {
                this.$set(this.parameter[0], "city", this.listRecords[0].city)
              }
              this.$forceUpdate()
            }
          }
          this.confirmLoading = false;
        });
      }
    }, confirm2() {
      //转学历咨询数据
      this.$utils.confirm.warning("提示", "确定转移到学历咨询数据吗？", () => {
        // console.log("dadadadad=========>", this.listConus[this.idx - 1].id)
        let conus = this.listConus[this.idx - 1]
        api.toXueli(
          { id: conus.id },
          (response) => {
            this.$utils.msg.success("添加成功");
            this.confirmLoading = false;
            conus.xlconusid = response.msg
            this.listNeedFlush += 1;
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });

    },
    //提交表单
    confirm() {

      if (this.parameter[0].state == "录入待通知") {
        this.$utils.msg.warning("请设置-数据状态");
        return false;
      }

      if (this.parameter[0].state == "已报名") {
        let param = this.$utils.merger(this.parameter[0]);
        param.state = 1
        this.$refs.add.open(param, param.name + ' 报名信息-教学交接表');
      } else {
        this.confirmLoading = true;

        let ids = [this.parameter[0].id];
        let rank = this.parameter[0].rank;
        let states = [this.parameter[0].state];
        let vdate = this.parameter[0].vdate;
        let remarks = [this.parameter[0].txt];
        let cities = [this.parameter[0].city];

        if (this.parameter[0].state == '有意向' || this.parameter[0].state == '已上门') {
          rank = 4;
        } else if (this.parameter[0].state == '可跟进') {
          rank = 3;
        } else if (this.parameter[0].state == '意向不大') {
          rank = 2;
        } else if (this.parameter[0].state == '无意向' || this.parameter[0].state == '废量') {
          rank = 1;
        }

        let param = {
          ids: ids,
          // ranks: ranks,
          vdate: vdate,
          remarks: remarks,
          states: states,
          cities: cities
        };

        api.attact(
          param,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.listRecords.splice(0, 0, {
              gjdate: "刚刚",
              remark: remarks[0],
              uid: "自己",
              rank: rank,
              city: cities[0],
              state: states[0]
            });
            this.sizeRecord++;
            this.listNeedFlush++;
            this.parameter[0].vdate = new Date();
            this.remark = "";

            this.parameter[0].rank = rank;
            this.parameter[0].state = states[0];
            this.parameter[0].city = cities[0];
            this.parameter[0].txt = ""
            this.listConus[this.idx - 1] = this.parameter[0];

          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      }
    },
    checkIsCangj() {
      this.isCangj = true;
      this.isCangjTxt = "提交跟进";
      if (
        this.me.role == "zx" ||
        this.me.role == "qd" ||
        this.me.role == "zm"
      ) {
        //验证是否可以跟进
        if (this.me.name != this.parameter[0].zxer) {
          this.isCangj = false;
          if (this.me.role == "zm" && this.parameter[0].zxer) {
            this.isCangjTxt = "指导" + this.parameter[0].zxer + "咨询";
            this.isCangj = true;
          }
        }
      }
    },
    init() {
      //清除等待
      this.confirmLoading = false;

      apircd.list({ coid: this.parameter[0].id }, (res) => {
        if (res.data.records) {
          this.listRecords = res.data.records;
          if (this.listRecords) {
            this.sizeRecord = this.listRecords.length;
            if (this.listRecords[0] && this.listRecords[0].city) {
              this.$set(this.parameter[0], "city", this.listRecords[0].city)
            }
          }
        }
      });

      //清楚校验
      this.$refs.form.clearValidate();
      this.popupLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
